module.exports = __webpack_public_path__ + "static/media/unquote.c20e4035.svg";